import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { humanizeLineItemCode } from '../../util/data';
import { LINE_ITEMS_TAX_PREFIX, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * Renders non-reversal line items that are not listed in the
 * `LINE_ITEMS` array in util/types.js
 *
 * The line items are rendered so that the line item code is formatted to human
 * readable form and the line total is printed as price.
 *
 * If you require another kind of presentation for your line items, add them to
 * the `LINE_ITEMS` array in util/types.js and create a specific line item
 * component for them that can be used in the `OrderBreakdown` component.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemTaxFeeMaybe = props => {
  const { lineItems, intl } = props;

  const taxFeeLineItem = lineItems.find(
    item => LINE_ITEMS_TAX_PREFIX.some(prefix => item.code.startsWith(prefix)) && !item.reversal
  );

  if (!taxFeeLineItem) return null;

  const label = humanizeLineItemCode(taxFeeLineItem.code);

  const formattedTotal = formatMoney(intl, taxFeeLineItem.lineTotal);
  return (
    <div key={taxFeeLineItem.code} className={css.lineItem}>
      <span className={css.itemLabel}>{label}</span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  );
};

export default LineItemTaxFeeMaybe;
